import React, { useRef, useState, useEffect } from "react";
import { useFormik } from "formik";
import { api } from "../../../../../../../../utility/AxiosInceptor";
import { Dialog } from "primereact/dialog";
import AddAgentDetail from "./Dialogs/add_agent_detail";
import { Dropdown } from "primereact/dropdown";
import { ProgressBar } from "primereact/progressbar";

import * as Yup from "yup";
import { InputText } from "primereact/inputtext";
import { Toast } from "primereact/toast";
import { Button } from "primereact/button";
import { FileIcon, UploadFile } from "../../../../../../../../utility";

export default function TabletBulkUploadAddStock({
  inventoryIdSelected,
  identifierTypeSelected,
  isFromhome,
  makeModel,
  unit,
  model,
  setFileUploadDetails,
  setFileUploadStatus,
  setAddUnits,
}) {
  const ref = useRef(null);
  const [filename, setFilename] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [addAgentDialogVisibility, setAddAgentDialogVisibility] =
    useState(false);
  const loginRes = localStorage.getItem("userData");
  const [agent, setAgent] = useState(null);
  const [department, setDepartment] = useState(null);
  const parseLoginRes = JSON.parse(loginRes);
  const [departmentselected, setDepartmentSelected] = useState(
    parseLoginRes?.department
  );
  const [carrier, setCarrier] = useState(null);
  const [progress, setProgress] = useState(0);
  useEffect(() => {
    if (department === null) {
      api
        .get(`/api/deparments/getDepartments?company=${parseLoginRes.company}`)
        .then((res) => {
          let departmentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].departmentName;
            obj.value = res.data.data[i].departmentId;
            departmentholder.push(obj);
          }
          setDepartment(departmentholder);
        })
        .catch(() => {});
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  useEffect(() => {
    if (departmentselected !== null) {
      api
        .get(`/api/web/user/getByDepartments?department=${departmentselected}`)
        .then((res) => {
          let agentholder = [];
          for (let i = 0; i < res.data.data.length; i++) {
            const obj = {};
            obj.label = res.data.data[i].name;
            obj.value = res.data.data[i]._id;
            agentholder.push(obj);
          }

          setAgent(agentholder);
        })
        .catch(() => {});
    }
  }, [departmentselected]);
  useEffect(() => {
    api
      .get(`/api/web/carrier/all`)
      .then((res) => {
        let carrierholder = [];
        for (let i = 0; i < res.data.data.length; i++) {
          const obj = {};
          obj.label = res.data.data[i].name;
          obj.value = res.data.data[i]._id;
          carrierholder.push(obj);
        }
        if (carrierholder.length === 1) {
          formik.setFieldValue("carrier", carrierholder[0].value);
        }

        setCarrier(carrierholder);
      })
      .catch(() => {});
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const formik = useFormik({
    validationSchema: Yup.object({
      carrier: Yup.string().required("Carrier is required"),

      AgentName: Yup.string().required("Agent Name is required"),
    }),
    initialValues: {
      carrier: "",
      file: "",
      serviceProvider: parseLoginRes?.company,
      agentType: parseLoginRes?.department,
      AgentName: parseLoginRes?._id,
      model: makeModel.substring(makeModel.lastIndexOf("-") + 2),
      make: makeModel.substring(0, makeModel.indexOf("-") - 1),
      unitType: unit,
      billingModel: model,
      Uploaded_by: parseLoginRes?._id,
      inventoryTypeId: inventoryIdSelected,
      identifierType: identifierTypeSelected,
    },

    onSubmit: (values, { resetForm }) => {
      if (formik.values.file !== "") {
        setIsLoading(true);
        const formData = new FormData();
        formData.append("file", formik.values.file);
        formData.append("serviceProvider", parseLoginRes?.company);
        formData.append("Uploaded_by", formik.values.Uploaded_by);
        formData.append("carrier", formik.values.carrier);
        formData.append("agentType", formik.values.agentType);
        formData.append("AgentName", formik.values.AgentName);
        formData.append("identifierType", formik.values.identifierType);
        formData.append("make", formik.values.make);
        formData.append("model", formik.values.model);
        formData.append("billingModel", formik.values.billingModel);
        formData.append("unitType", formik.values.unitType);
        formData.append("inventoryTypeId", inventoryIdSelected);
        // Perform API call or other actions with the formData

        api
          .post(`/api/web/simInventory/bulkAddInventory`, formData)
          .then((res) => {
            let uploadedInventoryResult = res?.data?.data;
            setFileUploadStatus(res?.data?.data);
            setIsLoading(false);

            // ref.current.show({ severity: "success", summary: "Inventory", detail: <ApiResponseShow res={res} /> });
            if (identifierTypeSelected === "BOTH") {
              if (
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.existingIMEINumbers.length > 0 ||
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.invalidSIMs.length > 0 ||
                uploadedInventoryResult.noBoxNoAddedForSIMS.length > 0 ||
                uploadedInventoryResult.emptySIMRows.length > 0 ||
                uploadedInventoryResult.invalidIMEILength.length > 0 ||
                uploadedInventoryResult.duplicateRows.length > 0
              ) {
                ref.current.show({
                  severity: "error",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              } else {
                ref.current.show({
                  severity: "success",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              }
            } else if (identifierTypeSelected === "ESN") {
              if (
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.existingIMEINumbers.length > 0 ||
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.invalidSIMs.length > 0 ||
                uploadedInventoryResult.noBoxNoAddedForSIMS.length > 0 ||
                uploadedInventoryResult.emptySIMRows.length > 0 ||
                uploadedInventoryResult.invalidIMEILength.length > 0 ||
                uploadedInventoryResult.duplicateRows.length > 0
              ) {
                ref.current.show({
                  severity: "error",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              } else {
                ref.current.show({
                  severity: "success",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              }
            } else {
              if (
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.existingIMEINumbers.length > 0 ||
                uploadedInventoryResult.existingSimNumbers.length > 0 ||
                uploadedInventoryResult.invalidSIMs.length > 0 ||
                uploadedInventoryResult.noBoxNoAddedForSIMS.length > 0 ||
                uploadedInventoryResult.emptySIMRows.length > 0 ||
                uploadedInventoryResult.invalidIMEILength.length > 0 ||
                uploadedInventoryResult.duplicateRows.length > 0
              ) {
                ref.current.show({
                  severity: "error",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              } else {
                ref.current.show({
                  severity: "success",
                  summary: "Inventory",
                  detail: <ApiResponseShow res={res} />,
                });
              }
            }
            resetForm();
            if (carrier.length === 1) {
              formik.setFieldValue("carrier", carrier[0].value);
            }
            setFilename(null);
            setFileUploadDetails(true);
          })
          .catch(() => {
            setIsLoading(false);
            ref.current.show({
              severity: "error",
              summary: "Inventory",
              detail: "Bulk Upload Failed",
            });
          });
      }
    },
  });
  function ApiResponseShow({ res }) {
    return (
      <>
        {identifierTypeSelected === "BOTH" ? (
          <div
            style={{ overflowY: "auto", height: "85vh" }}
            className="mainerror flex flex-wrap justify-content-left "
          >
            <p>{res?.msg}</p>
            <div>
              <p>
                {" "}
                Duplicate SIM Numbers :{" "}
                {res?.data?.data?.existingSimNumbers?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.existingSimNumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3">
              <p>
                {" "}
                Duplicate IMEI Numbers :{" "}
                {res?.data?.data?.existingIMEINumbers?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.existingIMEINumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3 w-full">
              <p>Sim Numbers Added: {res?.data?.data?.newSimNumbers?.length}</p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.newSimNumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>
                IMEI Numbers Added: {res?.data?.data?.newIMEINumbers?.length}
              </p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.newIMEINumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>Invalid SIMS: {res?.data?.data?.invalidSIMs?.length}</p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.invalidSIMs?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>
                No BoxNo Added For SIMS:{" "}
                {res?.data?.data?.noBoxNoAddedForSIMS?.length}
              </p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.noBoxNoAddedForSIMS?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3">
              <p> Empty SIMS Rows : {res?.data?.data?.emptySIMRows?.length}</p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.emptySIMRows?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3">
              <p>
                {" "}
                Invalid IMEI Length :{" "}
                {res?.data?.data?.invalidIMEILength?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.invalidIMEILength?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3 w-full">
              <p>Duplicate Rows: {res?.data?.data?.duplicateRows?.length}</p>
              <div className="">
                {res?.data?.data?.duplicateRows?.map((item) => (
                  <div
                    className="mt-1"
                    style={{
                      border: "solid black 1px",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                    }}
                  >
                    <p>{item?.ESN}</p>
                    <p>{item?.IMEI}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : identifierTypeSelected === "ESN" ? (
          <div
            style={{ overflowY: "auto", height: "85vh" }}
            className="mainerror flex flex-wrap justify-content-left "
          >
            <p>{res?.msg}</p>
            <div>
              <p>
                {" "}
                Duplicate SIM Numbers :{" "}
                {res?.data?.data?.existingSimNumbers?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.existingSimNumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3">
              <p>
                {" "}
                Duplicate IMEI Numbers :{" "}
                {res?.data?.data?.existingIMEINumbers?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.existingIMEINumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3 w-full">
              <p>Sim Numbers Added: {res?.data?.data?.newSimNumbers?.length}</p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.newSimNumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>
                IMEI Numbers Added: {res?.data?.data?.newIMEINumbers?.length}
              </p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.newIMEINumbers?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>Invalid SIMS: {res?.data?.data?.invalidSIMs?.length}</p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.invalidSIMs?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3 w-full">
              <p>
                No BoxNo Added For SIMS:{" "}
                {res?.data?.data?.noBoxNoAddedForSIMS?.length}
              </p>
              <ul className=" m-0 list-none">
                {res?.data?.data?.noBoxNoAddedForSIMS?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3">
              <p> Empty SIMS Rows : {res?.data?.data?.emptySIMRows?.length}</p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.emptySIMRows?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>
            <div className="mt-3">
              <p>
                {" "}
                Invalid IMEI Length :{" "}
                {res?.data?.data?.invalidIMEILength?.length}
              </p>
              <ul className="m-0 list-none errormsg  ">
                {res?.data?.data?.invalidIMEILength?.map((item) => (
                  <li>{item}</li>
                ))}
              </ul>
            </div>

            <div className="mt-3 w-full">
              <p>Duplicate Rows: {res?.data?.data?.duplicateRows?.length}</p>
              <div className="">
                {res?.data?.data?.duplicateRows?.map((item) => (
                  <div
                    className="mt-1"
                    style={{
                      border: "solid black 1px",
                      borderRadius: "0.5rem",
                      padding: "0.5rem",
                    }}
                  >
                    <p>{item?.ESN}</p>
                    <p>{item?.IMEI}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        ) : (
          ""
        )}
      </>
    );
  }
  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="flex flex-column">
          <div
            className="flex justify-content-between"
            style={{ marginTop: "1.2rem" }}
          >
            <div className="calendar_fieldaddunit">
              <div className="flex justify-content-between">
                <p className="field_labeladdunit ">
                  Carrier <span className="steric">*</span>
                </p>
                {formik.errors.carrier && formik.touched.carrier && (
                  <div className="p-error">{formik.errors.carrier}</div>
                )}
              </div>
              <Dropdown
                value={formik.values.carrier}
                options={carrier}
                onChange={(e) => formik.setFieldValue("carrier", e.value)}
                placeholder="Select an option"
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
            <div className="calendar_fieldaddunit">
              <p className="field_labeladdunit">
                Company Name <span className="steric">*</span>
              </p>
              <InputText
                value={parseLoginRes?.companyName}
                name="serviceProvider"
                disabled
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
          </div>
          <div
            className="flex justify-content-between"
            style={{ marginTop: "1.2rem" }}
          >
            <div className="calendar_fieldaddunit">
              <div className="flex justify-content-between">
                <p className="field_labeladdunit ">
                  Department/Vendor Name <span className="steric">* </span>
                </p>
                {formik.errors.agentType && formik.touched.agentType && (
                  <div className="p-error">{formik.errors.agentType}</div>
                )}
              </div>

              <Dropdown
                disabled
                value={formik.values.agentType}
                options={department}
                name="agentType"
                onChange={(e) => {
                  formik.setFieldValue("agentType", e.value);
                  setDepartmentSelected(e.value);
                  formik.handleChange(e);
                }}
                placeholder="Select an option"
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
            <div className="calendar_fieldaddunit">
              <div className="flex justify-content-between">
                <p className="field_labeladdunit ">
                  Agent Name <span className="steric">* </span>
                  {/* {formik.values.AgentName !== "" ? (
                                <Button style={{ border: "none", padding: "0rem", backgroundColor: "transparent" }} disabled={!permissions.isCreate}>
                                    {/*  <i
                                        onClick={() => {
                                            setAddAgentDialogVisibility((prev) => !prev);
                                        }}
                                        className="pi pi pi-plus"
                                        style={{ marginLeft: "0.5rem", fontSize: "1rem", color: "#fff", padding: "0.5rem", cursor: "pointer", paddingLeft: "1rem", borderRadius: "0.5rem", paddingRight: "1rem", background: "#00c0ef" }}
                                    ></i>  
                                </Button>
                            ) : undefined} */}
                </p>
                {formik.errors.AgentName && formik.touched.AgentName && (
                  <div className="p-error">{formik.errors.AgentName}</div>
                )}
              </div>
              <Dropdown
                disabled
                value={formik.values.AgentName}
                options={agent}
                onChange={(e) => formik.setFieldValue("AgentName", e.value)}
                placeholder="Select an option"
                className="dropdown"
                style={{ width: "32rem" }}
              />
            </div>
          </div>
          <div className="fileuploadmain">
            {progress > 0 && progress < 100 ? (
              <div className="progressbar">
                <div
                  className="flex"
                  style={{ gap: "1.2rem", height: "3.4rem" }}
                >
                  <span>
                    <FileIcon />
                  </span>
                  <div className="flex flex-column">
                    <p>{filename}</p>
                    <label>200 KB</label>
                  </div>
                </div>

                <div className="flex" style={{ gap: "1.2rem" }}>
                  <ProgressBar value={progress} showValue={false} />
                  <p>{progress}%</p>
                </div>
              </div>
            ) : progress === 0 ? (
              <div className="fileuploadinner">
                <span>
                  <UploadFile />
                </span>
                <h1>Drop file or browse</h1>
                <p>Format: .jpeg, .png & Max file size: 25 MB</p>
                <Button
                  type="button"
                  label={filename === null ? "Upload" : filename}
                  className="backbtn"
                  style={{
                    width: "30rem",
                    height: "3.4rem",
                    marginTop: "1.2rem",
                  }}
                  onClick={() => {
                    let input = document.createElement("input");
                    input.type = "file";
                    input.accept =
                      ".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                    input.click();

                    input.onchange = (e) => {
                      const file = e.target.files[0];
                      if (!file) return;

                      setFilename(file.name);
                      formik.setFieldValue("file", file);

                      // Simulate file upload progress
                      let progressValue = 0;
                      const interval = setInterval(() => {
                        progressValue += 10;
                        setProgress(progressValue);
                        if (progressValue >= 100) clearInterval(interval);
                      }, 300);
                    };
                  }}
                />
              </div>
            ) : (
              <div className="progressbar">
                <div
                  className="flex"
                  style={{ gap: "1.2rem", height: "3.4rem" }}
                >
                  <div className="flex flex-column">
                    <div className="flex" style={{ gap: "1.2rem" }}>
                      <span>
                        <FileIcon />
                      </span>
                      <div className="flex flex-column">
                        <p>{filename}</p>
                        <label>200 KB</label>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="flex" style={{ gap: "1.2rem" }}>
                  <p style={{ color: "#27AE60" }}>Completed</p>
                </div>
              </div>
            )}
          </div>
          {/* <div className="calendar_fieldaddunit">
                        <p className="field_labeladdunit  ">Upload File</p>
                        <Button
                            className="field-width justify-content-center "
                            type="button"
                            onClick={() => {
                                setFileError(false);
                                let input = document.createElement("input");
                                input.type = "file";
                                input.accept = ".xlsx, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";
                                input.click();
                                input.onchange = (e) => {
                                    setFilename(e.target.files[0].name);

                                    formik.setFieldValue("file", e.target.files[0]);
                                };
                            }}
                        >
                            {filename === null ? "Add File" : filename}
                        </Button>
                        {fileerror ? (
                            <p className="mt-2" style={{ color: "red" }}>
                                File is required
                            </p>
                        ) : undefined}
                    </div> */}
        </div>

        <div className="samplefilemain">
          <p className="flex">
            Choose a carrier to download its sample file for upload.
            {formik.values.carrier !== "" ? (
              <strong>
                {/* in carrier id is coming so use id hardcoded */}
                {formik.values.carrier === "64c00e80b42f66938aca04ca" ? (
                  <a href="/InventoryBulkUploadSample/tmb.xlsx">Sample File</a>
                ) : (
                  <a href="/InventoryBulkUploadSample/att.xlsx">Sample File</a>
                )}
                {/* {identifierTypeSelected === "ESN" ? <a href="/images/Sample_File_(ESN).xlsx">(Sample File)</a> : identifierTypeSelected === "IMEI" ? <a href="/images/Sample_File_(IMEI).xlsx">(Sample File)</a> : <a href="/images/Sample_File_(Both).xlsx">(Sample File)</a>} */}
              </strong>
            ) : (
              <h1>Sample File</h1>
            )}
          </p>
        </div>
        {/*<InfoForUsers ProvisionType={"AddStock"}/>*/}
        <Dialog
          style={{ width: "90vw" }}
          visible={addAgentDialogVisibility}
          onHide={() => {
            setAddAgentDialogVisibility((prev) => !prev);
          }}
        >
          <AddAgentDetail AgentName={"Dummy"} />
        </Dialog>
        <div
          style={{ gap: "1.6rem", marginTop: "3.2rem" }}
          className="flex flex-wrap justify-content-end w-full"
        >
          <Button
            className="backbtn"
            label="Back"
            type="button"
            onClick={() => {
              setAddUnits(false);
              // setActiveComponent("");
            }}
          />
          <Button
            label="Submit"
            className="nextbtn"
            type="submit"
            loading={isLoading}
          />
        </div>
        <Toast ref={ref} />
      </form>
    </>
  );
}
